// Copyright (c) 2019 Deere & Company

import * as fetchService from '../../shared/services/fetch';
import { getBasePath } from '../../shared/services/get-base-path';
import { handleError } from '../../shared/services/error-handlers';
// import { getUserIdFromSessionStorage } from '../../shared/services/user-service';

const basePath = getBasePath();
// let loggedInUserId = getUserIdFromSessionStorage();

export async function getProductSubSeries ( factoryCode, seriesId ) {

    const endPoint = `${basePath}/product-subseries?factoryCode=${factoryCode}&productSeriesId=${seriesId}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getBaseCodes ( factoryCode, seriesId, subSeriesId ) {

    const endPoint = `${basePath}/base-codes?productSeriesId=${seriesId}&productSubSeriesIds=${subSeriesId}&factoryCode=${factoryCode}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getWorklistSearchData ( searchedData ) {

    const endPoint = `${basePath}/worklist/search`;

    const options = {
        body: JSON.stringify( searchedData ),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}


export async function worklistRefineUpload ( file ) {

    const endPoint = `${basePath}/worklist-upload`;
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {
        const response = await fetchService.fetchforFileUpload( endPoint, options );
        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}